export default function Footer() {
  return (
    <footer data-testid="site-footer" className="flex flex-wrap items-center justify-between gap-6 border-t border-[#27272A] px-6 py-8 sm:px-10 lg:px-14">
      <div className="flex items-center gap-4">
        <img src="/assets/logo-duo.png" alt="Gentle&Monster logo" className="h-6 w-auto" />
        <p className="font-monoalt text-[10px] uppercase tracking-[0.3em] text-zinc-400">
          © 2026 Gentle&amp;Monster
        </p>
      </div>
      <p className="font-monoalt text-[10px] uppercase tracking-[0.3em] text-zinc-400">
        Meta Ads &amp; Creative Strategy
      </p>
    </footer>
  );
}
